export default "__VITE_ASSET__cUPve40J__"